<template>
  <div class="container mx-auto py-10 lg:pt-16">
    <div class="flex border-2 border-white bg-gray-100 rounded-lg shadow mx-10 xl:mx-0">
      <div class="w-full border-2 border-gray-100 -ml-5 -my-5 shadow-lg rounded-lg hidden xl:block">
        <a href="img/charlotte.jpg" target="_blank">
          <img class="object-cover h-full rounded-lg z-10 opacity-90 hover:opacity-100" src="img/charlotte-min.jpg" alt="Poulpy Chou">
        </a>
      </div>
      <div class="ml-4 pl-2 pr-6 py-6">
        <div class="flex">
          <div class="hidden md:block w-1/3 md:w-full xl:hidden mr-5">
            <a href="img/charlotte.jpg" target="_blank">
              <img class="object-cover h-full rounded-lg shadow hover:shadow-lg opacity-90 hover:opacity-100" src="img/charlotte-min.jpg" alt="Poulpy Chou">
            </a>
          </div>
          <div>
            <a href="img/charlotte.jpg" target="_blank">
              <img class="mb-4 md:hidden object-cover rounded-lg shadow hover:shadow-lg opacity-90 hover:opacity-100" src="img/charlotte-min.jpg" alt="Poulpy Chou">
            </a>

            <p class=text-xl>
              Je m’appelle Charlotte Raffin, alias <strong class="font-brand tracking-wider text-2xl">Poulpy Chou</strong>. Je suis illustratrice freelance.
            </p>

            <p class="mt-3 text-gray-800">
              Le dessin a toujours été une passion pour moi. Issue d’une formation en Design, je possède des notions en graphisme très utiles à la mise en forme des projets.
            </p>

            <p class="hidden lg:block mt-2 text-gray-800 text-justify">
              Si vous souhaitez un ou plusieurs dessins, gifs animés pour illustrer une histoire, promouvoir un évènement important, une marque, un produit, un service, n’hésitez pas à me contacter via e-mail. Je prendrai contact avec vous dans la journée ou selon vos disponibilités pour discuter de votre projet.
            </p>
          </div>
        </div>

        <p class="hidden sm:block lg:hidden mt-2 text-gray-800 text-justify">
          Si vous souhaitez un ou plusieurs dessins, gifs animés pour illustrer une histoire, promouvoir un évènement important, une marque, un produit, un service, n’hésitez pas à me contacter via e-mail. Je prendrai contact avec vous dans la journée ou selon vos disponibilités pour discuter de votre projet.
        </p>

        <ul class="mt-4 flex flex-wrap">
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Couvertures de livre</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Illustrations pour l’édition</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Dessin originaux</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Faire-part</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Affiches</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Menus</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Cartes</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Bannières et images de profil</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Etiquettes</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>Timbres</span></li>
            <li class="flex items-center w-full sm:w-1/2 lg:w-1/3 xl:w-1/2"><Bullet class="mr-2 text-gray-600" /> <span>&hellip;</span></li>
        </ul>

        <p class="mt-4 mb-2 leading-loose">
          Quelle que soit votre idée, n’hésitez pas à venir
          <router-link class="block text-center sm:inline-block ml-1 px-2 py-1 text-teal-100 bg-teal-500 hover:text-white rounded-lg shadow" :to="{name: 'contact'}">en discuter avec moi</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Bullet from '@/components/Bullet';

export default {
  components: {
    Bullet,
  },
}
</script>
